/**
 * Counting Nature - Bilingual flora/fauna for numbers 1-20
 * Used by the Counting Nature game (learn + quiz modes)
 */

export interface FloraFaunaItem {
  emoji: string;
  nameEn: string;
  nameEs: string;
  pluralEn: string;
  pluralEs: string;
  type: 'flora' | 'fauna';
}

export const floraFaunaData: FloraFaunaItem[] = [
  { emoji: '🌸', nameEn: 'Flower', nameEs: 'Flor', pluralEn: 'Flowers', pluralEs: 'Flores', type: 'flora' },
  { emoji: '🦋', nameEn: 'Butterfly', nameEs: 'Mariposa', pluralEn: 'Butterflies', pluralEs: 'Mariposas', type: 'fauna' },
  { emoji: '🌺', nameEn: 'Hibiscus', nameEs: 'Hibisco', pluralEn: 'Hibiscuses', pluralEs: 'Hibiscos', type: 'flora' },
  { emoji: '🐝', nameEn: 'Bee', nameEs: 'Abeja', pluralEn: 'Bees', pluralEs: 'Abejas', type: 'fauna' },
  { emoji: '🌻', nameEn: 'Sunflower', nameEs: 'Girasol', pluralEn: 'Sunflowers', pluralEs: 'Girasoles', type: 'flora' },
  { emoji: '🐛', nameEn: 'Caterpillar', nameEs: 'Oruga', pluralEn: 'Caterpillars', pluralEs: 'Orugas', type: 'fauna' },
  { emoji: '🌷', nameEn: 'Tulip', nameEs: 'Tulipán', pluralEn: 'Tulips', pluralEs: 'Tulipanes', type: 'flora' },
  { emoji: '🐞', nameEn: 'Ladybug', nameEs: 'Mariquita', pluralEn: 'Ladybugs', pluralEs: 'Mariquitas', type: 'fauna' },
  { emoji: '🌹', nameEn: 'Rose', nameEs: 'Rosa', pluralEn: 'Roses', pluralEs: 'Rosas', type: 'flora' },
  { emoji: '🦗', nameEn: 'Cricket', nameEs: 'Grillo', pluralEn: 'Crickets', pluralEs: 'Grillos', type: 'fauna' },
  { emoji: '🍀', nameEn: 'Clover', nameEs: 'Trébol', pluralEn: 'Clovers', pluralEs: 'Tréboles', type: 'flora' },
  { emoji: '🐌', nameEn: 'Snail', nameEs: 'Caracol', pluralEn: 'Snails', pluralEs: 'Caracoles', type: 'fauna' },
  { emoji: '🌼', nameEn: 'Daisy', nameEs: 'Margarita', pluralEn: 'Daisies', pluralEs: 'Margaritas', type: 'flora' },
  { emoji: '🦎', nameEn: 'Lizard', nameEs: 'Lagartija', pluralEn: 'Lizards', pluralEs: 'Lagartijas', type: 'fauna' },
  { emoji: '🌵', nameEn: 'Cactus', nameEs: 'Cactus', pluralEn: 'Cacti', pluralEs: 'Cactus', type: 'flora' },
  { emoji: '🐢', nameEn: 'Turtle', nameEs: 'Tortuga', pluralEn: 'Turtles', pluralEs: 'Tortugas', type: 'fauna' },
  { emoji: '🍄', nameEn: 'Mushroom', nameEs: 'Hongo', pluralEn: 'Mushrooms', pluralEs: 'Hongos', type: 'flora' },
  { emoji: '🐸', nameEn: 'Frog', nameEs: 'Rana', pluralEn: 'Frogs', pluralEs: 'Ranas', type: 'fauna' },
  { emoji: '🌿', nameEn: 'Leaf', nameEs: 'Hoja', pluralEn: 'Leaves', pluralEs: 'Hojas', type: 'flora' },
  { emoji: '🦜', nameEn: 'Parrot', nameEs: 'Loro', pluralEn: 'Parrots', pluralEs: 'Loros', type: 'fauna' },
];

export const numberWordsEn = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
  'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen', 'Twenty'];

export const numberWordsEs = ['', 'Uno', 'Dos', 'Tres', 'Cuatro', 'Cinco', 'Seis', 'Siete', 'Ocho', 'Nueve', 'Diez',
  'Once', 'Doce', 'Trece', 'Catorce', 'Quince', 'Dieciséis', 'Diecisiete', 'Dieciocho', 'Diecinueve', 'Veinte'];
